import { FormControl, InputBaseProps, InputLabel, TextField, TextFieldProps } from "@mui/material";
import React from "react";

type FormInputProps = TextFieldProps & {
  id: string;
  label: string;
  name: string;
};

function FormInput({ id, label, margin, inputProps, ...props }: FormInputProps) {
  return (
    <FormControl margin={margin} fullWidth variant="standard">
      <InputLabel
        sx={{
          fontSize: "1.2rem",
          mb: "0.5rem",
        }}
        htmlFor={id}
        shrink>
        {label}
      </InputLabel>
      <TextField
        size="medium"
        {...props}
        sx={[
          {
            mt: 3,
          },
        ]}
        margin="normal"
        InputLabelProps={{
          ...(props.InputLabelProps || {}),
          shrink: true,
          sx: {
            fontSize: "30px",
            marginBottom: "5rem",
            paddingBottom: "5rem",
          },
        }}
        InputProps={{ ...((inputProps || {}) as InputBaseProps), id }}
      />
    </FormControl>
  );
}

export default FormInput;
